/**
 * Footer — the shared pre-auth footer link row. Lives on the Landing page and
 * on every standalone content page (About, Plans, How memory works, Terms,
 * Privacy, the magnet essay) so the links are reachable from anywhere, not
 * just the home page. Handlers come from App's goTo() router so cross-page
 * navigation resets the prior page's flag.
 */
export default function Footer({ onAbout, onPricing, onMemory, onTerms, onPrivacy }) {
  return (
    <footer className="px-4 pt-10 pb-10 flex items-center justify-center gap-3 text-xs text-slate-600">
      <button onClick={onAbout} className="hover:text-slate-400 transition-colors">About</button>
      <span>·</span>
      <button onClick={onPricing} className="hover:text-slate-400 transition-colors">Plans</button>
      <span>·</span>
      <button onClick={onMemory} className="hover:text-slate-400 transition-colors">How memory works</button>
      <span>·</span>
      <button onClick={onTerms} className="hover:text-slate-400 transition-colors">Terms</button>
      <span>·</span>
      <button onClick={onPrivacy} className="hover:text-slate-400 transition-colors">Privacy</button>
    </footer>
  );
}
